import estilos from '../DetalleSolicitudDeEntrega/DetalleDeEntregaComponent.module.css'
import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { withRouter } from 'react-router-dom'

const InformacionDeEntregaComponent = (props) => {

    const detalleEntrega = useSelector(store => store.ModuloEntregas.detalleEntrega)

    const { api = undefined } = props
    const { handdleInformacionEntrega } = api

    var sumaProductos = props?.productos?.reduce((sum, value) => (typeof value.numerobotellas == "number" ? sum + value.numerobotellas : sum), 0);
    let fechaHoy = moment().format('YYYY-MM-DD');

    const [hologramasEntregados, setHologramasEntregados] = React.useState('')
    //const [lote, setLote] = React.useState('')
    const [folioinicial, setFolioInicial] = React.useState('')
    const [foliofinal, setFolioFinal] = React.useState('')
    const [hologramasRestantes, setHologramasRestantes] = React.useState('')
    const [inventarioFinal, setInventarioFinal] = React.useState('')
    const [prefijo, setPrefijo] = React.useState('')

    const [openModal, setOpenModal] = React.useState(false)
    const [titleModal, setTitleModal] = React.useState('')
    const [bodyModal, setBodyModal] = React.useState('')
    const [botonModal, setBotonModal] = React.useState('')
    const [deshabilitarBoton, setDeshabilitarBoton] = React.useState(false)
    const cancelarModal = () => setOpenModal(false)

    React.useEffect(async () => {
        if (detalleEntrega?.informacionentregahologramas?.length == 0) {
            if (detalleEntrega?.formato == 'FC_09') {
                setInventarioFinal(Number(Number(detalleEntrega.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasmezcal) - Number(hologramasEntregados)))
                setHologramasRestantes(Number(Number(sumaProductos) - Number(hologramasEntregados)))
            }
            if (detalleEntrega?.formato == 'FC_33') {
                setInventarioFinal(Number(Number(detalleEntrega.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasmezcal) - Number(hologramasEntregados)))
                setHologramasRestantes(Number(Number(sumaProductos) - Number(hologramasEntregados)))
            }

            if (detalleEntrega?.formato == 'FC_41') {
                setInventarioFinal(Number(Number(detalleEntrega.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasbebidas) - Number(hologramasEntregados)))
                setHologramasRestantes(Number(Number(sumaProductos) - Number(hologramasEntregados)))
            }
        } else {
            let sumaEntregas = detalleEntrega?.informacionentregahologramas?.[0]?.entregashologramas?.reduce((sum, value) => sum + Number(value.hologramasentregados), 0);

            if (detalleEntrega?.formato == 'FC_09') {
                setInventarioFinal(Number(Number(detalleEntrega.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasmezcal) - Number(hologramasEntregados)))
                setHologramasRestantes(Number((Number(Number(sumaProductos) - Number(sumaEntregas))) - Number(hologramasEntregados)))
            }
            if (detalleEntrega?.formato == 'FC_33') {
                setInventarioFinal(Number(Number(detalleEntrega.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasmezcal) - Number(hologramasEntregados)))
                setHologramasRestantes(Number((Number(Number(sumaProductos) - Number(sumaEntregas))) - Number(hologramasEntregados)))
            }
            if (detalleEntrega?.formato == 'FC_41') {
                setInventarioFinal(Number(Number(detalleEntrega.login?.cliente?.[0]?.inventarioclientehologramas?.[0].hologramasbebidas) - Number(hologramasEntregados)))
                setHologramasRestantes(Number((Number(Number(sumaProductos) - Number(sumaEntregas))) - Number(hologramasEntregados)))
            }
        }
    }, [hologramasEntregados])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };

    const guardarCambios = async () => {
        let hologramasSolicitados = Number(hologramasEntregados)
        let sugerencia = Number(Number(folioinicial) + hologramasSolicitados - 1)

        if (hologramasEntregados == '' || folioinicial == '' || foliofinal == '' || prefijo == '') {
            setTitleModal("¡Tenemos un problema!")
            setBodyModal("La entrega no se puede realizar si existe un campo vacío. Asegurate de llenar todos los campos requeridos.")
            setBotonModal("Aceptar")
            setOpenModal(true)
        } else if (Number(foliofinal) > sugerencia) {
            setTitleModal("Existe un error con el folio final.")
            setBodyModal("El folio final no es válido. Ingresa un folio que coincida con el total de hologramas entregados.")
            setBotonModal("Aceptar")
            setOpenModal(true)
        } else if (Number(inventarioFinal) < 0){
            setTitleModal("¡Error!")
            setBodyModal("El inventario no es suficiente para la cantidad de hologramas a entregar.")
            setBotonModal("Aceptar")
            setOpenModal(true)
        } else if (Number(props?.productos?.length) != props?.infoProductos?.length) {
            setTitleModal("¡Tenemos un problema!")
            setBodyModal("La entrega no se puede realizar si a los productos no le ha adjuntado información.")
            setBotonModal("Aceptar")
            setOpenModal(true)
        } else {
            setTitleModal("Confirmación de compra.")
            setBodyModal("¿Estás seguro que deseas realizar la compra? No se podrán realizar cambios después.")
            setBotonModal("Continuar")
            setOpenModal(true)
        }
    }

    const closeModal = async () => {
        if (botonModal == "Continuar") {

            let fechaAceptada = new Date(fechaHoy).toISOString()
            let datos = {
                fecha: fechaAceptada, hologramassolcitados: sumaProductos, hologramasentregados: hologramasEntregados,
                folioinicial: folioinicial, foliofinal: foliofinal, restante: hologramasRestantes, inventariofinal: inventarioFinal,
                prefijo: prefijo
            }
            await handdleInformacionEntrega(datos)
            setOpenModal(false)
            //setDeshabilitarBoton(true)

        } else
            setOpenModal(false)
    }

    const cancelarCambios = () => {
        props.history.push('/PanelEntregasComponent')
    }

    return (
        <fieldset className={`${estilos.contenedor} mt-2 row `}>
            <legend className="float-none w-auto p-2 text-start"> Información de entrega </legend>
            <div className='col-md-6'>
                <div className="form-floating mb-2">
                    <input type="number" min="0" className={`form-control `} id="floatingInput" disabled
                        value={sumaProductos} />
                    <label htmlFor='floatingInput'>Hologramas solicitados: </label>
                </div>
            </div>
            <div className='col-md-6'>
                <div className="form-floating mb-2">
                    <input type="number" min="0" className={`form-control `} id="floatingInput" value={hologramasEntregados} onChange={e => setHologramasEntregados(e.target.value)} onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} />
                    <label htmlFor='floatingInput'>Hologramas a entregar:</label>
                </div>
            </div>

            <div className='col-md-2 mt-3'>
                <div className="form-floating mb-2">
                    <select className={`form-select`}
                        value={prefijo} onChange={e => setPrefijo(e.target.value)}>
                        <option value="">Seleccione un prefijo</option>
                        <option value={`A`} >{`A`}</option>
                        <option value={`B`} >{`B`}</option>
                    </select>
                    <label htmlFor='floatingInput'>Prefijo</label>
                </div>
            </div>
            <div className='col-md-2 mt-3'>
                <div className="form-floating mb-2">
                    <input type="number" min="0" className={`form-control `} id="floatingInput" value={folioinicial} onChange={e => setFolioInicial(e.target.value)} onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} />
                    <label htmlFor='floatingInput'>Folio inicial:</label>
                </div>
            </div>
            <div className='col-md-2 mt-3'>
                <div className="form-floating mb-2">
                    <input type="number" min="0" className={`form-control `} id="floatingInput" value={foliofinal} onChange={e => { setFolioFinal(e.target.value) }} onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} />
                    <label htmlFor='floatingInput'>Folio final:</label>
                </div>
            </div>
            <div className='col-md-3 mt-3'>
                <div className="form-floating mb-2">
                    <input type="number" min="0" className={`form-control `} id="floatingInput" value={hologramasRestantes}
                        onChange={e => { setHologramasRestantes(e.target.value) }} onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                        disabled />
                    <label htmlFor='floatingInput'>Hologramas restantes:</label>
                </div>
            </div>
            <div className='col-md-3 mt-3'>
                <div className="form-floating mb-2">
                    <input type="number" min="0" className={`form-control `} id="floatingInput" value={inventarioFinal}
                        onChange={e => { setInventarioFinal(e.target.value) }} onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                        disabled />
                    <label htmlFor='floatingInput'>Inventario final: </label>
                </div>
            </div>
            
            <Fragment>
                <div className='col-md-6 mt-3'>
                    <button onClick={() => guardarCambios()} className='btn btn-outline-success' disabled={deshabilitarBoton}>Aplicar entrega</button>
                </div>
                <div className='col-md-6 mt-3'>
                    <button onClick={() => cancelarCambios()} className='btn btn-outline-danger'>Cancelar entrega</button>
                </div>
            </Fragment>

            <Modal
                open={openModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <center><strong>{titleModal}</strong></center>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <center>{bodyModal}</center>
                    </Typography>
                    <Typography sx={{ mt: 5 }}>
                        <button className={`btn ${estilos.botonModal}`} onClick={closeModal}> {botonModal} </button>
                    </Typography>
                    {
                        botonModal == "Continuar" &&
                        <Typography sx={{ mt: 2 }}>
                            <button className={`btn ${estilos.botonCancelarModal}`} onClick={cancelarModal}> Cancelar </button>
                        </Typography>

                    }
                </Box>
            </Modal>
        </fieldset>
    );
};


export default withRouter(InformacionDeEntregaComponent)